import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Alert, Button, Col, Container, Row } from "reactstrap";
import { contactErrorMessageClear, contactSuccessClear, sendMessage } from "../store/Contact/actions";
import { IconCircleCheck, IconLoader2 } from "@tabler/icons-react";
import useGoogleReCaptcha from "./Recaptcha";

const Contact = (props) => {

  const { isPending, isSuccess, errorMessage } = props;
  const { executeRecaptcha } = useGoogleReCaptcha('6LdP4FosAAAAAPufEZ1L4F27Pjf5E0h61H_6B2Rd');
  const initialContactData = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    message: "",
    enquiry: "",
    leadName: null,
    contact: null,
  };

  const [contactData, setContactData] = useState();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    props.contactErrorMessageClear();
    props.contactSuccessClear();
    setContactData(initialContactData);
  }, [])
  useEffect(() => {
    if (isSuccess) {
      setContactData(initialContactData);
      setErrors({});
    }
  }, [isSuccess]);

  const handleInputChnages = (e) => {
    const { name, value } = e.target || {};

    let result = {};

    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      result = {
        isValid: !emailRegex.test(value),
        message: 'Enter valid email address',
      };
    }
    // if (name === 'phoneNo' && value) {
    //   const contactNumberRegex = /^\d{10}$/;
    //   result = {
    //     isValid: !contactNumberRegex.test(value),
    //     message: 'Enter valid phone number',
    //   };
    // }

    setContactData({
      ...contactData,
      [name]: value
    })

    setErrors({
      ...errors,
      [name]: result.isValid ? result.message : null,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const recaptchaToken = await executeRecaptcha('homepage');

    const { firstName, lastName, email, phoneNo, enquiry, message } = contactData || {};
    const name = firstName && lastName ? firstName + lastName : firstName;
    let currentErrors = {};

    if (!firstName || !firstName?.trim()) {
      currentErrors.firstName = "First name is required";
    }
    if (!email || !email?.trim()) {
      currentErrors.email = "Email is required.";
    }
    if (errors && errors.email) {
      currentErrors.email = 'Enter valid email address';
    }
    if (errors && errors.phoneNo) {
      currentErrors.phoneNo = 'Enter valid phone number';
    }
    if (!message || !message?.trim()) {
      currentErrors.message = "Message is required.";
    }
    setErrors(currentErrors);
    const owner = window.__ENV && window.__ENV.leadowner;

    if (Object.keys(currentErrors).length === 0) {
      const dataToSend = {
        leadName: name,
        contact: name,
        categoryName: enquiry || '',
        email: email,
        phoneNo: phoneNo,
        message: message,
        qualificationLevel: "cold",
        leadWebsite: "Matrix Vision",
        source: "web",
        sendMail: true,
        leadOwner: owner
      }
      console.log("recaptchaToken:", recaptchaToken);
      props.sendMessage({ ...dataToSend, token: recaptchaToken });
      // .then(() => {
      //   setContactData({
      //     ...contactData,
      //     leadName: null,
      //     contact: null,
      //     email: null,
      //     phoneNo: null,
      //     message: null
      //   })
      // })
    }

  }
  console.log("error: ", errors);
  console.log('contactData:', contactData);
  return (
    <React.Fragment>
      <section className="section" id="contact">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="heading-box text-center">
                <h3 className="heading-title">
                  <span className="fw-normal">Let's talk about</span>{" "}
                  everything!
                </h3>
                <p className="heading-desc text-muted mt-3">
                  Have questions or need assistance? We're just a message away.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center pt-4 mt-5">
            <Col lg={3}>
              <div className="mt-4">
                <h5 className="f-17 mb-1 mt-4 pt-2">Email Address</h5>
                <p className="text-muted">senthil@matrixvision.co.in</p>
                <div className="mt-4">
                  <h5 className="f-17 mb-1">Contact Number</h5>
                  <p className="text-muted">+91-9886554012</p>
                </div>
                {/* <div className="mt-4">
                  <h5 className="f-17 mb-1">Office Address</h5>
                  <p className="text-muted ms-4">
                    -
                  </p>
                </div> */}
              </div>
            </Col>
            <Col lg={8}>
              {errorMessage && <Col lg={8}>
                <Alert color="danger">{errorMessage}</Alert>
              </Col>}
              {isSuccess && <Col lg={8}>
                <Alert color="success">Your message was sent successfully.</Alert>
              </Col>}
              <div className="custom-form mt-4">
                <form method="post" name="myForm">
                  <p id="error-msg"></p>
                  <div id="simple-msg"></div>
                  <Row>
                    <Col lg={6}>
                      <div className="form-group mt-2">
                        <input
                          name="firstName"
                          id="name"
                          type="text"
                          className="form-control"
                          placeholder="Your first name *"
                          onChange={handleInputChnages}
                          value={contactData?.firstName}
                        />
                        {errors?.firstName && <small className="text-danger">{errors?.firstName}</small>}
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="form-group mt-2">
                        <input
                          name="lastName"
                          id="name"
                          type="text"
                          className="form-control"
                          placeholder="Your last name"
                          onChange={handleInputChnages}
                          value={contactData?.lastName}
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="form-group mt-2">
                        <input
                          name="phoneNo"
                          id="phoneNo"
                          type="number"
                          className="form-control"
                          placeholder="Your phone no"
                          onChange={handleInputChnages}
                          value={contactData?.phoneNo}
                        />
                        {errors?.phoneNo && <small className="text-danger">{errors?.phoneNo}</small>}
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="form-group mt-2">
                        <input
                          name="email"
                          id="email"
                          type="email"
                          className="form-control"
                          placeholder="Your email *"
                          onChange={handleInputChnages}
                          value={contactData?.email}
                        />
                        {errors?.email && <small className="text-danger">{errors?.email}</small>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="form-group mt-2">
                        <textarea
                          name="message"
                          id="message"
                          rows={4}
                          className="form-control"
                          placeholder="Your message *..."
                          onChange={handleInputChnages}
                          value={contactData?.message}
                        ></textarea>
                        {errors?.message && <small className="text-danger">{errors?.message}</small>}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col lg={12}>
                      <Button
                        className={`btn btn-success  me-3 ${!isPending ? "label-btn" : "btn-loader"}`}
                        onClick={handleSubmit}
                        disabled={isPending}
                      >
                        {!isPending ?
                          <span className="label-btn-icon"><IconCircleCheck size={21} /></span>
                          :
                          <span className="label-btn-loader"><IconLoader2 size={21} className="spin" /></span>
                        }
                        <span className={isPending && "ms-2"}> Send Message</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  isPending: state.contact.isContactPending,
  isSuccess: state.contact.isContactSuccess,
  errorMessage: state.contact.contactErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  sendMessage: (data) => dispatch(sendMessage(data)),
  contactErrorMessageClear: () => dispatch(contactErrorMessageClear()),
  contactSuccessClear: () => dispatch(contactSuccessClear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
